import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replace' })
export class ReplacePipe implements PipeTransform {
  transform(value: any, selection: string, replacement: string): any {
    return `${value}`.replace(new RegExp(selection, 'g'), replacement);
  }
}
